import {Tags} from 'Event/attendee'
import {Font} from 'Event/Marketplace/lib/font'
import {Group} from 'organization/Event/AttendeesProvider'

export type ButtonStyles = {
  width?: number
  height?: number
  fontSize?: number
  font?: Font | null
  textColor?: string
  hoverTextColor?: string
  backgroundColor?: string
  hoverBackgroundColor?: string
  borderColor?: string
  hoverBorderColor?: string
  borderRadius?: number
  borderWidth?: number
}

export type CalendarStyles = {
  font?: Font | null
  fontSize?: number
  height?: number
  width?: number
  borderColor?: string
  hoverBorderColor?: string
  borderWidth?: number
  borderRadius?: number
}

export type WidgetSources =
  | 'url'
  | 'cookie'
  | 'local_storage'
  | 'session_storage'
  | 'custom'

export type WidgetCalendarProviders = 'google' | 'outlook' | 'yahoo' | 'apple'

export type CalendarEventType = 'timed' | 'multi'

export interface RedirectTemplate {
  enabled: boolean
  delay: number
  text: string
}

export interface ButtonTemplate {
  enabled: boolean
  label: string
  styles: ButtonStyles
}

export interface CalendarTemplate {
  enabled: boolean
  label: string
  providers: WidgetCalendarProviders[]
  eventType: CalendarEventType
  eventStart: string | null
  eventEnd: string | null
  styles: CalendarStyles
}

export interface WidgetTemplate {
  redirect: RedirectTemplate
  button: ButtonTemplate
  calendar: CalendarTemplate
}

export interface Widget {
  id: number
  token: string
  tags: Tags
  groups: Group[]
  allowed_origins: string[] | null
  email_source: WidgetSources
  email_source_key: string
  first_name_source: WidgetSources
  first_name_source_key: string
  last_name_source: WidgetSources
  last_name_source_key: string
  event_title: string | null
  event_description: string | null
  timezone: string
  template: WidgetTemplate
}

export const DEFAULT_WIDGET_TEMPLATE: WidgetTemplate = {
  redirect: {
    enabled: false,
    delay: 0,
    text: 'Redirecting you to the event dashboard…',
  },
  button: {
    enabled: false,
    label: 'Redirect to Dashboard',
    styles: {
      width: 250,
      fontSize: 16,
      height: 45,
      font: {
        styles: ['caps'],
        family: '',
        variants: [],
      },
    },
  },
  calendar: {
    enabled: false,
    label: 'Add to Calendar',
    providers: ['apple', 'google', 'outlook', 'yahoo'],
    eventType: 'timed',
    eventStart: null,
    eventEnd: null,
    styles: {
      width: 250,
      fontSize: 16,
      height: 45,
      font: {
        styles: ['caps'],
        family: '',
        variants: [],
      },
    },
  },
}
